import { ReactSVG } from 'react-svg'

import './styles.scss'

export const FormErrorMessage = ({
  classPrefix,
  message,
}: {
  message: string
  classPrefix: string
}) => {
  return (
    <div className={`form-error-message-container ${classPrefix}__form-error-message-container`}>
      <ReactSVG src="/icons/warning.svg" />
      <div
        className={`form-error-message-container__message ${classPrefix}__form-error-message-container__message`}>
        {message}
      </div>
    </div>
  )
}
